import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  margin: 12% 0 4% 15.625%;
  flex-direction: column;
  justify-content: center;
  max-width: 35vw;

  @media (max-width: 1024px) {
    max-width: 100vw;
    margin: 26% 0 0 0;
  }
`;

export const ButtonContainer = styled.div`
  max-width: 400px;
  margin: 15px 0 15px 0;

  @media (max-width: 1024px) {
    max-width: 100vw;
    margin: 5% 15% 0 15%;
  }
`;

export const Paragraph = styled.p`
  font-size: 1.125rem;
  font-weight: 300;
  color: #ffffff;
  max-width: 35vw;
  margin: 15px 0 15px 0;

  @media (max-width: 1024px) {
    max-width: 100vw;
    font-size: 5vw;
    margin: 5% 15% 0 15%;
  }
`;

export const Icon = styled.img`
  width: 93px;
  height: 83px;
  margin: 15px 0 15px 0;

  @media (max-width: 1024px) {
    margin: 5% 15% 0 15%;
  }
`;

export const SnackbarContainer = styled.div`
  margin-top: 38.5px;
`;
